function toggleContent(element, dataAttribute) {
    // Obtener el contenedor padre (el elemento más cercano con ID)
    const container = element.closest('[id]');
    if (!container) return;
    
    // Remover clases activas de todos los elementos de la lista
    const listItems = container.querySelectorAll(`[data-${dataAttribute}]`);
    listItems.forEach(item => {
      item.classList.remove('mx-bg-[#0d97ce]','mx-text-white','mx-border-0','mx-cursor-default')
      item.classList.add('mx-bg-white','hover:mx-bg-[#ea0029]','hover:mx-text-white','mx-border','mx-border-solid','mx-border-gray-300','mx-cursor-pointer')
    });
    
    // Agregar clases al elemento clickeado
    element.classList.add('mx-bg-[#0d97ce]','mx-text-white','mx-border-0','mx-cursor-default')
    element.classList.remove('mx-bg-white','hover:mx-bg-[#ea0029]','hover:mx-text-white','mx-border','mx-border-solid','mx-border-gray-300','mx-cursor-pointer')
    
    // Obtener el ID del contenido a mostrar
    const targetId = element.getAttribute(`data-${dataAttribute}`);
    
    // Ocultar todos los contenidos
    const contents = container.querySelectorAll('[id^="trending-"]');
    contents.forEach(content => {
      if (content.id) {
        content.classList.add('mx-hidden');
      }
    });
    
    // Mostrar el contenido seleccionado
    const targetContent = container.querySelector(`#${targetId}`)
    if (targetContent) {
      targetContent.classList.remove('mx-hidden');
    }
  }

  function handleScrollFade(containerId,leftFadeId,rightFadeId,opacityClass) {
    const container = document.getElementById(containerId)
    const leftFade = document.getElementById(leftFadeId)
    const rightFade = document.getElementById(rightFadeId)
    const opacity = opacityClass
    
    function updateFades() {
      // Mostrar/ocultar fade izquierdo basado en scroll position
      if (container.scrollLeft > 0) {
        leftFade.classList.remove(opacity);
      } else {
        leftFade.classList.add(opacity);
      }
      
      // Mostrar/ocultar fade derecho basado en si hay más contenido para scroll
      if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
        rightFade.classList.add(opacity);
      } else {
        rightFade.classList.remove(opacity);
      }
    }
    
    // Actualizar en scroll
    container.addEventListener('scroll', updateFades);
    
    // Actualizar en resize
    window.addEventListener('resize', updateFades);
    
    // Actualizar estado inicial
    updateFades();
  }